'use strict';
const angular = require('angular');

import {IBasketUtilsService, IBasket} from '../../interfaces';

export const NUMBER_PAYMENTS = 4;

/*@ngInject*/
export class BasketUtilsService implements IBasketUtilsService {

    /**
     * Get the right price.
     * It can be a custom price from the admin side (Same value for the old unique price)
     * Or it can be the new price selection from the user side
     * 
     * @param basket
     */
    public getPrice(basket: IBasket) {
      let basketPrice = 0;
      
      if (basket.price) {
          basketPrice = basket.price;
      } else if (basket.newPrice) {
          basketPrice = basket.newPrice.price;
      }

      return basketPrice;
    }
}

function BasketResource($resource) {
  'ngInject';
  return $resource('/api/baskets/', {}, {});
}


export default angular.module('terrappApp.basketUtils', [])
  .factory('Basket', BasketResource)
  .service('BasketUtils', BasketUtilsService)
  .name;



// WEBPACK FOOTER //
// ./client/app/services/basketService/basketUtils.service.ts